import { Component, Input } from '@angular/core';
import { NoDataMessageComponent } from '../../../../clinician-dashboard/shared/components/no-data-message/no-data-message.component';
import { LoaderSmallComponent } from '../../loaders/loader-small/loader-small.component';


@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: true,
    imports: [LoaderSmallComponent, NoDataMessageComponent]
})
export class CardComponent {

  public loadingValue$ = false;

  @Input() headerBackground: 'blue' | 'grey' = 'blue';

  @Input() set loading(content: boolean) {
    this.loadingValue$ = content;
  }

  @Input() rounded = false;

  /**
   * A variable that will dictate the displaying of the no data message provided (if no message is provided then the default generic
   * message will be used)
   */
  public noDataFoundValue$ = false;

  @Input() set noDataFound(content: boolean) {
    this.noDataFoundValue$ = content;
  }

  @Input() noDataMessage: string = null;
}
